import React from "react";
import NavBtn from "../NavBtn";
import { GiTakeMyMoney } from "react-icons/gi";

const OtherExpenses = (props) => {
  const {
    exactPath = "/dashboard/expenses",
    to = "/dashboard/expenses",
    partialPath = "/expenses",
    label = "Other Expenses",
  } = props;

  return (
    <NavBtn
      label={label}
      exactPath={exactPath}
      partialPath={partialPath}
      to={to}
      Icon={GiTakeMyMoney}
    />
  );
};

export default OtherExpenses;
